<template>
    <navbar>
        <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
            &#9776;
        </button>
        <!--<a class="navbar-brand"></a>-->
        <ul class="nav navbar-nav d-md-down-none">
            <li class="nav-item">
                <a class="nav-link navbar-toggler sidebar-toggler" @click="sidebarMinimize">&#9776;</a>
            </li>
        </ul>

        <!--<ul class="nav navbar-nav d-md-down-none">-->
        <!--<li class="nav-item header-item">-->
        <!--<router-link tag="div" to='/' style="height:55px;" class="nav-link">-->
        <!--<p>-->
        <!--<Icon type="compose" size='30' color="#2d8cf0"></Icon>-->
        <!--</p>-->
        <!--<p style="color:white"> 留言管理 </p>-->
        <!--</router-link>-->
        <!--</li>-->
        <!--<li class="nav-item header-item">-->
        <!--<Dropdown>-->
        <!--<router-link tag="div" to='/' style="height:55px;" class="nav-link">-->
        <!--<p>-->
        <!--<Icon type="android-cloud" size='30' color="#2d8cf0"></Icon>-->
        <!--</p>-->
        <!--<p style="color:white"> 云服务器 </p>-->
        <!--</router-link>-->
        <!--<DropdownMenu slot="list">-->
        <!--<DropdownItem>Linux</DropdownItem>-->
        <!--<DropdownItem>Mac OS X</DropdownItem>-->
        <!--<DropdownItem>Windows</DropdownItem>-->
        <!--<DropdownItem>Core OS</DropdownItem>-->
        <!--</DropdownMenu>-->
        <!--</Dropdown>-->
        <!--</li>-->
        <!--</ul>-->


        <ul class="nav navbar-nav ml-auto">

            <Dropdown class="nav-item">
                <a href="javascript:void(0)">
           <span slot="button">
          <img :src="userImage" style="width: 40px;height:40px" class="img-avatar" alt="o">
          <span class="d-md-down-none">{{username}}</span>&nbsp;
          </span>
                </a>
                <Dropdown-menu slot="list">
                    <Dropdown-item>
                        <p class="dropdown-itemp" @click="changePwds">
                            <Icon type="android-settings"></Icon>
                            修改密码
                        </p>
                    </Dropdown-item>
                    <Dropdown-item divided><a href="" @click="Logout">
                        <p class="dropdown-itemp">
                            <Icon type="power"></Icon>
                            退出登录
                        </p>
                    </a>
                    </Dropdown-item>
                </Dropdown-menu>
            </Dropdown>
        </ul>
    </navbar>
</template>
<script>

    import navbar from './Navbar'

    export default {
        name: 'header',
        components: {
            navbar,

        },
        props: ['changePwd'],
        methods: {
            Logout(e) {
                e.preventDefault();
                this.$store.dispatch('LogOut').then(() => {
                    this.$router.push({path: '/login'});
                }).catch(err => {
                    this.$message.error(err);
                });
            },
            sidebarMinimize(e) {
                e.preventDefault()

                document.body.classList.toggle('sidebar-minimized')
            },
            mobileSidebarToggle(e) {
                e.preventDefault()

                document.body.classList.toggle('sidebar-mobile-show')
            },
            changePwds() {
                this.changePwd.can = true;
                this.changePwd.oldPwd = '';
                this.changePwd.newPwd = '';
                this.changePwd.newPwdAgain = '';

            }
        },
        computed: {
            username() {
                return this.$store.getters.name;
            },
            userImage() {
                return this.$store.getters.avatar;
            },
        }
    }
</script>

<style type="text/css" scoped>
    .dropdown-itemp {
        text-align: left;
        font-size: 15px;
        padding: 10px;
    }

    .header-item .ivu-dropdown-item {
        padding: 15px;
    }

    .header-item {
        width: 130px;
        /*background-color: #20a8d8;*/
        /*background-color: white;*/

        height: 55px;

    }

    .header-item a {
        color: white !important;

    }

</style>



// WEBPACK FOOTER //
// Header.vue?af786c22